import { render, staticRenderFns } from "./GenexAvatar.vue?vue&type=template&id=0348737a&scoped=true&"
import script from "./GenexAvatar.vue?vue&type=script&setup=true&lang=js&"
export * from "./GenexAvatar.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./GenexAvatar.vue?vue&type=style&index=0&id=0348737a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0348737a",
  null
  
)

export default component.exports